<script>
    // "설정" 탭 — 링크 프리뷰 커스텀 / 아바톡 프로필 수정(+커스텀 URL) / 분석 관리(GA ID).
    // 통계(방문·클릭 그래프)는 별도 공유 컴포넌트(insights/StatisticsDashboard.svelte)로 분리됨.
    import {PRConnect} from "@projectroom/ui-lib";
    import {onMount} from 'svelte';
    import axios from "axios";
    import HubAccessSetting from "./hub/HubAccessSetting.svelte";

    export let bot;
    let readOnlyFlag = true;
    let addThumbnailImageInput;
    let isModifyFlag = false;
    let isDuplicateUrl = false;
	let isValidMessage = false;
	let refDesignateUrlValidMessage;
	let isDuplicateUrlChecked = true;
    let refEditFileInput;

    class BotProfile {

        constructor({id, title, subTitle, scriptCode, thumbnailImageContent, thumbnailImageTitle, thumbnailImageSubTitle, iconImageContent, designateUrl}) {
            this.id = id;
            this.title = title;
            this.subTitle = subTitle;
            this.scriptCode = scriptCode;
            this.thumbnailImageContent = thumbnailImageContent;
            this.thumbnailImageTitle = thumbnailImageTitle;
            this.thumbnailImageSubTitle = thumbnailImageSubTitle;
            this.iconImageContent = iconImageContent;
            this.designateUrl = designateUrl;
			this.isDesignateUrl = this.designateUrl ? true : false;
        }

        save() {
            if (isDuplicateUrl && this.designateUrl) {
                this.designateUrl = null;
            }
            // ⚠️ 허브는 이름(TITLE)·소개 문구(SUB_TITLE)를 [기본] 탭(HubBasic)이 갖는다. 이 저장은 두 컬럼을
            //    같이 쓰는데 값은 이 탭이 처음 불러온 것이라, 그대로 보내면 [기본] 탭에서 고친 것을 되돌린다.
            //    → 허브면 빌더의 최신 값(HubBasic 이 bot 에 맞춰 둔다)으로 보낸다.
            if (bot.isHub) {
                this.title = bot.title;
                this.subTitle = bot.subTitle;
            }
            PRConnect.send("/api/Bot/modifyBotStatisticsData", {...this}, data => {
                if( data.header.status === "success") {
                    console.log("staticsManagement update success");
                }
            });
        }

        deleteDesignateUrl() {
            this.designateUrl = null;
        }
        checkDesignateUrl() {

			if (!isValidCustomURLInput()) {
				refDesignateUrlValidMessage.innerText = "영문자, 숫자만 사용가능합니다.";
				isValidMessage = true;
				return;
			}
			isDuplicateUrlChecked = false;
            PRConnect.send("/api/Bot/checkDesignateUrl", {id:this.id, designateUrl: this.designateUrl}, data => {
                if( data.header.status === "success") {
                    if (data.result.id) {
                        isDuplicateUrl = true;
						refDesignateUrlValidMessage.innerText = "해당 Custom URL은 이미 존재합니다.";
        				isValidMessage = true;
                    } else {
                        isDuplicateUrl = false;
						if (!isValidCustomURLInput()) {
							refDesignateUrlValidMessage.innerText = "영문자, 숫자만 사용가능합니다.";
							isValidMessage = true;
							return;
						}
						refDesignateUrlValidMessage.innerText = "";
						isValidMessage = false;
                    }
					isDuplicateUrlChecked = true;
                }
            });
        }
        changeUseDesignateUrl() {
			if (!bot.isAuthority("tabType","statisticsManagement")) {
				return;
			}
			this.isDesignateUrl = !this.isDesignateUrl;
            if (!this.isDesignateUrl) {
				this.designateUrl = null;
				this.save();
			}
			botProfile = botProfile;
        }

        getIconImageContent() {
            return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/${this.id}/common/profile-images/${this.iconImageContent}`;
        }

		getFullDesignateUrl() {
			return `${location.origin}/view/@${this.designateUrl || ''}`;
		}

        changeIconImageContent(imageContent) {
            this.iconImageContent = imageContent;
            this.save();
        }

		isShowFullDesignateUrl() {
			return this.isDesignateUrl && this.designateUrl?.length > 0 && !isDuplicateUrl;
		}
    }
    let botProfile = {};

    onMount(() => {
        PRConnect.send("/api/Bot/getBotInfoByBotId", {id:bot.id}, data => {
            if( data.header.status === "success") {
                botProfile = new BotProfile(data.result.botData);
            }
        });
    });

    const clickGoogleAnalisticsAssign = () => {
        readOnlyFlag = true;
        botProfile.save();
    }
    const clickGoogleAnalisticsModify = () => {
		if (!bot.isAuthority("tabType","statisticsManagement")) {
			return;
		}
        readOnlyFlag = !readOnlyFlag;
    }

    const onThumbnailImageSelected = (e) => {
        const file = e.target.files[0];
        const key = `${bot.id}/common/thumbnail-image/${file.name}`;
        const type = file.type ? file.type : "application/octet-stream";
        PRConnect.send("/api/File/uploadPresignedUrl", {key, type}, data => {
            axios.put(data.result, file, {headers: {"Content-Type": type}})
            .then( response =>{
                if (response.status == 200) {
                    botProfile.thumbnailImageContent = file.name;
                    botProfile.save();
                }
            });
        });
    }

    const clickThumbnailImageDelete = () => {
        botProfile.thumbnailImageContent = null;
        botProfile.save();
    }

    const getThumbnailImageContent = () => {
        return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/${botProfile.id}/common/thumbnail-image/${botProfile.thumbnailImageContent}`;
    }

    const onImageFileSelected = (e) => {
        let image = e.target.files[0];
        const key = `${botProfile.id}/common/profile-images/${image.name}`;
        const type = image.type;
        PRConnect.send("/api/File/uploadPresignedUrl", {key, type}, data => {
            axios.put(data.result, image, {headers: {"Content-Type": type}})
            .then( response =>{
                botProfile.changeIconImageContent(image.name);
            });
        });
    }

    const changeBotProfile = () => {
        try {
            botProfile.save();
            isModifyFlag = false;
        } catch (error) {
            console.log(error);
        }
    }

	const isValidCustomURLInput = () => {
		// 영문자,숫자만 가능
		const pattern = /^[a-zA-Z0-9]+$/;
		return pattern.test(botProfile.designateUrl);
	}

	const clickThumbnailImage = () => {
		if (!bot.isAuthority("availableType", "THUMBNAIL_IMAGE")) {
			return false;
		}
		addThumbnailImageInput.click();
	}

	const clickThumbanilIsAvailable = () => {
		bot.isAvailableType("availableType", "THUMBNAIL_IMAGE");
	}

</script>
<div data-w-tab="Tab 4" class="google-analistics-tab-pane w-tab-pane tw-font-sans tw-text-foreground"
    class:w--tab-active={bot.currentTab==="statisticsManagement" } on:click={()=> isModifyFlag = false}>
    <div class="graph-tab">
        <!-- 허브 접근 설정(허브에만). 화면 구성이 아니라 '누가 들어오나'라서 설정 탭이 제자리다. -->
        {#if bot.isHub}
            <HubAccessSetting {bot} />
        {/if}
        <div class="statistics-title-wrapper">
			<div class="tab-text sub3 statistics-title">{"링크 프리뷰 커스텀"}</div>
			{#if !bot.isAvailableType("tabType","statisticsManagement")}
			<img class="lock-image" src="/static/images/lock.svg" />
			{/if}
		</div>
        <div class="graph-con center">
            <div class="link-preview">
                {#if botProfile.thumbnailImageContent}
                <div class="logo-image-wrapper">
                    <img src={getThumbnailImageContent()} loading="lazy" alt="" class="image-151 logo-image">
                    <img loading="lazy" src="/static/images/trashcan-icon.svg" class="logo-image-delete pointer" on:click={clickThumbnailImageDelete}>
                </div>
                {:else}
                <img src="/static/images/upload-icon-big.svg" loading="lazy" alt="" class="image-151">
                {/if}
                <div>
                    <input type="file"  bind:this={addThumbnailImageInput} on:change={onThumbnailImageSelected} hidden/>
                    <a href="#" class="image-upload-button w-button" on:click={clickThumbnailImage}>
                        {#if botProfile.thumbnailImageContent}
                        {"링크 미리보기 이미지 재업로드"}
                        {:else}
                        {"링크 미리보기 이미지 업로드"}
                        {/if}
                    </a>
                </div>

				{#if bot.isAvailableType("tabType","statisticsManagement")}
				<div class="div-block-88" on:mouseleave={botProfile.save()}>
                    <div class="link-title-form w-form">
                        <div id="email-form" name="email-form" data-name="Email Form" method="get" class="form-3"
                            aria-label="Email Form">
                            <input type="text" bind:value={botProfile.thumbnailImageTitle} class="link-text-form w-input" maxlength="256" name="name-5" data-name="Name 5" placeholder={"링크 제목을 입력해주세요! 예시 )그냥이 아바톡!"}>
                        </div>
                    </div>
                    <div class="link-title-form w-form">
                        <div id="email-form" name="email-form" data-name="Email Form" method="get" class="form-3"
                            aria-label="Email Form">
                            <input type="text" bind:value={botProfile.thumbnailImageSubTitle} class="link-sub-text-form w-input" maxlength="256" name="name-6" data-name="Name 6" placeholder={"설명을 입력해주세요! 예시 ) 안녕! 나는 그냥저냥 사는 그냥이야~! 만나서 반갑다냥!"} id="name-6">
                        </div>
                    </div>
                </div>
				{:else}
				<div class="div-block-88" on:click={clickThumbanilIsAvailable}>
                    <div class="link-title-form w-form">
                        <div id="email-form" name="email-form" data-name="Email Form" method="get" class="form-3"
                            aria-label="Email Form">
                            <input type="text" readonly bind:value={botProfile.thumbnailImageTitle} class="link-text-form w-input" maxlength="256" name="name-5" data-name="Name 5" placeholder={"링크 제목을 입력해주세요! 예시 )그냥이 아바톡!"}>
                        </div>
                    </div>
                    <div class="link-title-form w-form">
                        <div id="email-form" name="email-form" data-name="Email Form" method="get" class="form-3"
                            aria-label="Email Form">
                            <input type="text" readonly bind:value={botProfile.thumbnailImageSubTitle} class="link-sub-text-form w-input" maxlength="256" name="name-6" data-name="Name 6" placeholder={"설명을 입력해주세요! 예시 ) 안녕! 나는 그냥저냥 사는 그냥이야~! 만나서 반갑다냥!"} id="name-6">
                        </div>
                    </div>
                </div>
				{/if}
            </div>
        </div>
        <div class="tab-text-wrap _2">
            <div class="tab-text">{"아바톡 프로필 수정 "} </div>
            <div class="tab-text sub">{"(아바톡 목록에서 보여지는 프로필을 수정합니다.)"}</div>
        </div>
        <div class="graph-con">
            <a href="#" class="profile-change w-button" on:click|stopPropagation={()=> isModifyFlag = true}>{"프로필 수정하기"}</a>
        </div>
        <div class="statistics-title-wrapper">
			<div class="tab-text sub3 statistics-title">{"분석 관리"}</div>
			{#if !bot.isAvailableType("tabType","statisticsManagement")}
			<img class="lock-image" src="/static/images/lock.svg" />
			{/if}
		</div>
        <div class="graph-con">
            <div class="analysis-wrap">
                <div class="tab-text sub2">{"구글 애널리틱스 ID 입력"}</div>
                <div class="analysis-input">
                    <div class="analysis-block-form">
                        <div class="text-block-94">{"고유 코드 입력 창"}</div>
                        <div class="div-block-76">
                            <div class="youtube-input-form w-form">
                                <div id="email-form" name="email-form" data-name="Email Form" class="analysis-form"
                                    aria-label="Email Form">
                                    <input type="text" class="analysis-text-form w-input" bind:value={botProfile.scriptCode} autofocus="true" maxlength="256"  placeholder="traking ID" readonly={readOnlyFlag}>
                                </div>
                                {#if readOnlyFlag}
                                <a href="#" class="profile-change off w-button"
                                    on:click={clickGoogleAnalisticsModify}>{"입력하기"}</a>
                                {:else}
                                <a href="#" class="profile-change w-button"
                                    on:click={clickGoogleAnalisticsAssign}>{"적용하기"}</a>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="frofile-setting-popup" class:flex={isModifyFlag} on:click={()=> isModifyFlag = false}>
    <div class="popup-layer frofile" on:click|stopPropagation>
        <div class="titile-text">
            <div class="h1 margin20">{"아바톡 프로필 설정"}</div>
            <div class="title-sub">{"아바톡 목록에서 보여질 프로필을 설정해주세요!"}</div>
        </div>
        <div class="frofile-setting-button">
            {#if botProfile.iconImageContent}
            <img class="avatar-img" src={botProfile.getIconImageContent()} alt="userImage">
            {:else}
            <div class="frofile-image blank"></div>
            {/if}
            {#if botProfile.iconImageContent}
            <div class="file-upload-btn edit" on:click={()=> botProfile.changeIconImageContent(null)}>
                <div class="file-upload-text" on:click|stopPropagation={()=>refEditFileInput.click()}>{"이미지 편집"}</div>
            </div>
            {:else}
            <a href="#" class="button w-button" on:click={()=>refEditFileInput.click()}>{"파일 업로드"}</a>
            {/if}
            <input accept="image/png, image/jpeg, image/jpg" bind:this={refEditFileInput}
                                       type="file" name="modify" on:change={(event)=>onImageFileSelected(event)} hidden>
        </div>
        <div class="profile-form">
            <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-2">
                <!-- ⚠️ 허브는 [기본] 탭이 '허브 이름'(BOTS.TITLE)·'소개 문구'(BOTS.SUB_TITLE)를 갖는다.
                     둘 다 자동저장이라 같이 열어 두면 한쪽이 다른 쪽을 덮어쓴다 → 허브에서는 여기서 숨긴다. -->
                {#if !bot.isHub}
                <label for="name" class="field-label">{"아바톡 이름 설정"}</label>
                <input type="text" class="avatalk-name-setting w-input" bind:value={botProfile.title} maxlength="256" name="name" data-name="Name" placeholder={"ex) 그냥이"} id="name">
                <label for="email" class="field-label-2">{"아바톡 소개글"}<span> {"(최대30자)"}</span></label>
                <input type="text" class="avatalk-name-setting w-input" bind:value={botProfile.subTitle} maxlength="256" name="email" data-name="Email" placeholder={"ex) 아바톡 대표 캐릭터 그냥이!"} id="email" required="">
                {/if}
				<div class="designate-url-wrapper">
					<label for="email" class="field-label-2 custom-url-title">{"아바톡 Custom URL"}</label>
					<div class="toggle-button _2" on:click={()=>botProfile.changeUseDesignateUrl()}>
						<div class="toggle" class:on={botProfile.isDesignateUrl}></div>
						<div class="toggle-round" class:on={botProfile.isDesignateUrl}></div>
					</div>
					{#if !bot.isAvailableType("tabType","statisticsManagement")}
					<img class="designate-url-lock-image" src="/static/images/lock.svg" />
					{/if}
				</div>
                {#if botProfile.isDesignateUrl}
					<div class="designate-url-context-wrapper">
						<input type="text" class="designate-url avatalk-name-setting w-input" bind:value={botProfile.designateUrl} maxlength="256" name="email" data-name="Email" placeholder={"아바톡 URL을 작성해주세요!"} id="email" on:keyup={()=>botProfile.checkDesignateUrl()}>
						<img src="/static/images/check-icon.svg" class="designate-url-check-icon" class:unchecked={isDuplicateUrl}>
					</div>
					<label for="name-3" class="fail-message" class:show={isValidMessage} bind:this={refDesignateUrlValidMessage} />
					{#if botProfile.isShowFullDesignateUrl()}
						<label for="name-3" class="success-message">
						{botProfile.getFullDesignateUrl()}
						</label>
					{/if}
                {/if}
				{#if isDuplicateUrlChecked}
                <a href="#" class="save-button w-button" on:click={()=>changeBotProfile()}>{"변경하기"}</a>
				{:else}
				<a href="#" class="save-button unchecked-url w-button">{"Custom URL 확인중"}</a>
				{/if}
            </form>
        </div>
        <div class="x-button pointer" on:click={()=> isModifyFlag = false}></div>
    </div>
</div>
<style>

	.success-message {
		display: block;
	}

	.designate-url-wrapper {
		display: flex;
	}

	.designate-url-check-icon {
		background-color: #15c747;
		border-radius: 10px;
		width: 14px;
		position: absolute;
    	right: 8px;
    	top: 7px;
	}

	.unchecked {
		background-color: red;
	}

	.designate-url {
		background-image: none;
	}

	.save-button.unchecked-url {
		border-color: gray;
	}

	.designate-url-context-wrapper {
		position: relative;
	}

	.custom-url-title {
		margin-top: 5px;
    	margin-right: 12px;
	}

    .name-text-form {
        font-size: 14px;
    }

    .logo-image-wrapper {
        position: relative;
        padding: 28px;
        border: 1px solid #6472ff;
        border-radius: 10px;
        margin-bottom: 10px;
    }

    .logo-image {
        width: 140px;
        margin-bottom: 0px;
    }

    .logo-image-delete {
        position: absolute;
        top: 4px;
        right: 4px;
        cursor: pointer;
    }

    .analysis-form {
        width: 540px;
        display: inline-block;
        margin-right: 10px;
        padding: 2px 2px;
    }

    .profile-change {
        padding: 5px 15px;
        border-radius: 8px;
        height: 30px;
    }

    .off {
        background-color: #808697;
    }

    .graph-tab {
        width: auto;
    }

    .flex {
        display: flex;
    }

    .frofile-setting-popup {
        position: fixed;
    }

    .popup-layer.frofile {
        height: auto;
    }

    .profile-form {
        width: 400px
    }

    .avatar-img {
        margin-right: 14px;
        width: 60px;
        height: 60px;
        margin-bottom: 5px;
        border-radius: 100px;
    }

    .toggle {
        background-color: gray;
    }

    .toggle.on {
        width: 46px;
        height: 26px;
        background-color: #ff558d;
        border: 1px #ff558d;
        border-radius: 30px;
    }

    .field-label-2 {
        display: inline-block;
    }

    .save-button {
        display: block;
        width: 100%;
    }

    .graph-con {
        position: relative;
    }

	.statistics-title {
		display: inline-block;
    	margin-right: 0px;
	}

	.lock-image {
		padding-bottom: 7px;
	}

	.designate-url-lock-image {
		padding-left: 5px;
    	padding-top: 4px;
	}

	/* ── shadcn 토큰 리스킨 (append — 뒤 규칙이 이김). DOM/바인딩 보존, 색·표면만 --sb-* ── */
	.tab-text,
	.tab-text.sub3 {
		color: hsl(var(--sb-foreground));
	}
	.tab-text.sub,
	.tab-text.sub2 {
		color: hsl(var(--sb-muted-foreground));
	}
	.logo-image-wrapper {
		border: 1px solid hsl(var(--sb-border));
		background-color: hsl(var(--sb-muted) / 0.4);
	}
	.name-text-form,
	.analysis-form {
		background-color: hsl(var(--sb-background));
		color: hsl(var(--sb-foreground));
		border: 1px solid hsl(var(--sb-input));
		border-radius: 6px;
	}
	.toggle {
		background-color: hsl(var(--sb-input));
	}
	.toggle.on {
		background-color: hsl(var(--sb-primary));
		border-color: hsl(var(--sb-primary));
	}
	.profile-change,
	.save-button {
		background-color: hsl(var(--sb-primary));
		color: hsl(var(--sb-primary-foreground));
		border-radius: 8px;
	}
</style>
